// extracted by css-extract-rspack-plugin
var _1 = "summaryItem-s_wd_L";
var _2 = "summaryLabel-xTk7kg";
var _3 = "summaryList-ZFccSj";
var _4 = "summaryValue-fDSIjo";
export { _1 as "summaryItem", _2 as "summaryLabel", _3 as "summaryList", _4 as "summaryValue" }
